<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="70" style="vertical-align: text-top">
      <h4 style="vertical-align: text-top">Card activities</h4>
    </div>
    <div fxFlex="30" class="text-right">


    </div>

  </mat-card-header>



  <div>

      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">



          <mat-form-field class="mccgroup-filter-field">
            <mat-select [formControl]="mccGroupSelect" placeholder="MCC Group" multiple>
              <mat-option *ngFor="let mccGroup of mccGroups" [value]="mccGroup.index">{{mccGroup.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                         [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
          <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                         [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
          <mat-form-field class="date-filter-field">
            <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
              <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">
                {{dateFilter.header}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <app-number-input class="search-field" (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Bill Amount >=" [(value)]="this.filters.numberFrom"></app-number-input>
          <app-number-input class="search-field" (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Bill Amount <=" [(value)]="this.filters.numberTo"></app-number-input>


          <mat-form-field class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="table.filters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()"
                  [disabled]="startDateFilter.invalid || endDateFilter.invalid">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>

        </div>

    </div>

  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="cardActivitiesTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [customActions]=""
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'activityDate'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>
</mat-card>


